const RecipesReducer = (state=[], action) => {
    switch(action.type){
        case 'AddRecipe':
            console.log(action.payload);
            return [...state,action.payload];
        default :
            return state;
    }
}
export default RecipesReducer;